import { render, staticRenderFns } from "./AddTypeModal.vue?vue&type=template&id=5f85c714&scoped=true&lang=html"
import script from "./AddTypeModal.vue?vue&type=script&lang=js"
export * from "./AddTypeModal.vue?vue&type=script&lang=js"
import style0 from "./AddTypeModal.vue?vue&type=style&index=0&id=5f85c714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f85c714",
  null
  
)

export default component.exports